module.exports = __webpack_public_path__ + "img/logonetcar.7a6009fb.png";